import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import {
  getServices,
  updateServices,
} from "../../../../apiServices/apiServices";
import { useNavigate } from "react-router-dom";
import NoInternetComp from "../../InternetConnetction/NoInternetComp";

function Trackorder() {
  const [trackOrders, setTrackOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const access_token = sessionStorage.getItem("access-token");
  const navigate = useNavigate();

  useEffect(() => {
    if (navigator.onLine) {
      fetchTrackOrdersData();
    }
  }, []);

  const fetchTrackOrdersData = async () => {
    setLoading(true);
    const res = await getServices(
      `/api/notifications/admin-order-notifications`,
      access_token,
    );
    setLoading(false);
    if (res?.responseData) {
      setTrackOrders(res.responseData);
    }
  };

  const extractOrderNumber = (message) => {
    const match = message.match(/#(\S+)/);
    return match ? match[1] : null;
  };

  const handleOrderClick = async (order) => {
    if (!order.is_read) {
      await updateServices(
        `/api/notifications/admin-order-notifications/mark-read/${order.track_id}`, // ✅ full path
        access_token,
      );
      setTrackOrders((prev) =>
        prev.map((o) =>
          o.track_id === order.track_id ? { ...o, is_read: true } : o,
        ),
      );
    }
    navigate("/admin/order/details", { state: { id: order.track_id } });
  };

  const handleMarkAllRead = async () => {
    await updateServices(
      `/api/notifications/admin-order-notifications/mark-all-read`, // ✅ full path
      access_token,
    );
    setTrackOrders((prev) => prev.map((o) => ({ ...o, is_read: true })));
  };

  // ✅ Count directly from DB field
  const unreadCount = trackOrders.filter((order) => !order.is_read).length;

  return (
    <>
      {navigator.onLine ? (
        <Container>
          <Container className="flex justify-between items-center mx-0 px-4 md:px-8 py-8">
            <p className="text-xl sm:text-2xl font-semibold">
              Orders Notification
            </p>
            <div className="flex items-center gap-3">
              {unreadCount > 0 && (
                <>
                  <span className="bg-red-700 text-white text-xs font-semibold px-2.5 py-1 rounded-full">
                    {unreadCount} unread
                  </span>
                  {/* <button
                    onClick={handleMarkAllRead}
                    className="text-xs text-blue-600 underline hover:text-blue-800"
                  >
                    Mark all as read
                  </button> */}
                </>
              )}
            </div>
          </Container>
          <Container className="px-4 md:px-8">
            {loading ? (
              <Container className="min-h-[35vh] flex justify-center items-center">
                <p className="text-center font-semibold">Loading...</p>
              </Container>
            ) : trackOrders?.length >= 1 ? (
              <div className="flex flex-col gap-3">
                {trackOrders.map((order) => {
                  const isRead = order.is_read; // ✅ directly from DB
                  const orderNo = extractOrderNumber(order.message);

                  return (
                    <div
                      key={order.track_id}
                      onClick={() => handleOrderClick(order)}
                      className={`flex items-start justify-between rounded-lg p-4 cursor-pointer transition-all duration-200
                        ${
                          isRead
                            ? "bg-white border border-gray-200 shadow-sm hover:shadow-md"
                            : "bg-amber-50 border border-amber-100 shadow-md hover:shadow-lg"
                        }`}
                    >
                      <div className="flex items-start gap-3">
                        <div
                          className={`mt-1 w-2.5 h-2.5 rounded-full shrink-0 ${
                            isRead ? "bg-gray-300" : "bg-red-500"
                          }`}
                        ></div>
                        <div>
                          <div className="flex items-center gap-2">
                            <p
                              className={`text-sm font-semibold ${
                                isRead ? "text-gray-500" : "text-gray-800"
                              }`}
                            >
                              {order.title}
                            </p>
                            {!isRead && (
                              <span className="text-[10px] bg-red-100 text-red-600 font-semibold px-1.5 py-0.5 rounded-full">
                                New
                              </span>
                            )}
                          </div>
                          <p className="text-sm text-gray-500 mt-0.5">
                            {order.message
                              .split(orderNo ? `#${orderNo}` : "")
                              .map((part, i, arr) =>
                                i < arr.length - 1 ? (
                                  <React.Fragment key={i}>
                                    {part}
                                    <span className="text-stone-600 font-medium underline hover:text-blue-800">
                                      {orderNo}
                                    </span>
                                  </React.Fragment>
                                ) : (
                                  part
                                ),
                              )}
                          </p>
                        </div>
                      </div>
                      <span className="text-xs text-gray-400 whitespace-nowrap ml-4 mt-1">
                        {order.time}
                      </span>
                    </div>
                  );
                })}
              </div>
            ) : (
              <Container className="text-center font-semibold">
                <p>No data found!!!</p>
              </Container>
            )}
          </Container>
        </Container>
      ) : (
        <Container className="min-h-[65vh] flex flex-col justify-center items-center">
          <NoInternetComp />
        </Container>
      )}
    </>
  );
}

export default Trackorder;
